module.exports = __webpack_public_path__ + "assets/img/travel-day28.9aa01d05.png";